export default "__VITE_ASSET__a7ab6075__"